var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSubscription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39462 9.01696C2.41385 8.99775 2.43385 8.97931 2.45538 8.96164L11.5338 2.15948C11.7892 1.98582 11.7938 1.98658 12.0938 2.01271C12.2238 2.03499 12.3462 2.08417 12.4569 2.15948L19.3769 7.34409C19.9169 7.78824 19.7408 8.11329 19.5508 8.39146C19.3185 8.73188 18.8062 8.81333 18.4538 8.57358L11.9954 3.734L4.15692 9.60712L11.9954 14.1747L20.8346 9.02388C20.8346 9.02388 21.1831 8.89863 21.4008 8.94012C21.7392 9.03848 21.9738 9.33356 21.9908 9.68704C21.9908 13.0251 22.0115 16.3632 21.9908 19.7005C21.9685 20.89 20.94 21.9535 19.7131 21.9758C14.5677 22.0081 9.42308 22.0081 4.27769 21.9758C3.08077 21.9535 2.00769 20.9292 2 19.6743V12.7592C2.02385 12.2636 2.25385 12.1499 2.44923 12.0607C2.91154 11.8502 3.51231 12.2183 3.53769 12.7592C3.53769 15.0699 3.49462 17.3806 3.53769 19.6912C3.55 20.0847 3.89923 20.4328 4.29692 20.4397C9.43231 20.472 14.5685 20.535 19.7031 20.4397C20.0962 20.4274 20.4454 20.0808 20.4531 19.6813V11.0241L12.3831 15.7269C12.0223 15.9144 11.8808 15.8691 11.6077 15.7269L2.38154 10.3502C1.91923 10.0505 1.92077 9.29129 2.39462 9.01696Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubscription);
export default __webpack_public_path__ + "static/media/icon_subscription.3580849c.svg";
export { ForwardRef as ReactComponent };